import { jsx as _jsx } from "react/jsx-runtime";
import DefaultSpinner from './assets/SpinnerSVG';
const Spinner = ({ spinner, spinnerColor }) => {
    return (_jsx("div", Object.assign({ style: {
            position: 'fixed',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            width: '100%',
            height: '100%',
            outline: '0',
            zIndex: 10001,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0)',
        } }, { children: spinner ? spinner : spinner !== false && _jsx(DefaultSpinner, { spinnerColor: spinnerColor }, void 0) }), void 0));
};
export default Spinner;
